import React, { useCallback, useEffect } from "react";
import { Navigate, Outlet, Route, useLocation, useNavigate } from "react-router-dom";
import { useLoggedContext } from "./AuthContext";
import { isLogged } from "../Utils/AuthUtils";
import { GetGoBackFlag, SetGoBackFlag } from "../Utils/BaseUtils";

const PublicRoute = (props:any) => {
  const {auth, setAuth} = useLoggedContext();
  const navigate = useNavigate();
  const location = useLocation().pathname.replace('/', '');
  useEffect(() => {
    if (auth !== isLogged()) {
      setAuth(isLogged());
    }
    console.log(location);
    // const urls = process.env.REACT_APP_ALLOWED_URLS?.split(',');
    // window.addEventListener("message", (event) => {
    //      if (urls?.includes(event.origin)) {
    //          if (event?.data?.auth) {
    //              localStorage.setItem('Authorization', event.data.auth);
    //              setAuth(true);
    //          }
    //          if (navigate) {
    //             navigate(event.data.path);
    //          }
    //          window.parent.postMessage({pageLoaded: true}, '*');
    //      }
    // }, false);
  },[]);
  // if (GetGoBackFlag()) {
  //   if (auth) {
  //     navigate(-1);
  //     SetGoBackFlag('false');
  //     return null;
  //   } else {
  //     return <Outlet />
  //   }
  // } else {
    return <>{!auth ? <Outlet /> : <Navigate to="/" />}</>;
  //}
 
};

export default PublicRoute;